'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRole = exports.getRolesInAccount = exports.fetchRoles = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchRoles = exports.fetchRoles = function fetchRoles() {
  return (0, _callApi2.default)('GET', '/roles');
};
var getRolesInAccount = exports.getRolesInAccount = function getRolesInAccount(account_id) {
  return (0, _callApi2.default)('GET', '/roles/' + account_id, null, 'application/json');
};
var deleteRole = exports.deleteRole = function deleteRole(role_id) {
  return (0, _callApi2.default)('DELETE', '/roles/delete-role', { id: role_id }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/roleManagement.js
// module id = 742
// module chunks = 0